// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"b33c19c4","498":"dd51f93d","513":"0d94a8f9"}[chunkId] + ".chunk.js";
};